import { FAQLayout, LayoutConfig } from './types';

export const LAYOUT_CONFIG: Record<FAQLayout, LayoutConfig> = {
  row: {
    desktopDirection: 'lg:flex-row',
    mobileDirection: 'max-lg:flex-col',
    gap: 'gap-x-8 max-lg:gap-y-14',
    accordionWidth: 'lg:w-[60%]',
    ctaWidth: 'lg:w-[40%]',
    ctaDirection: 'flex-col',
  },
  'row-reverse': {
    desktopDirection: 'lg:flex-row-reverse',
    mobileDirection: 'max-lg:flex-col-reverse',
    gap: 'gap-x-6 max-lg:gap-y-14',
    accordionWidth: 'lg:w-[60%]',
    ctaWidth: 'lg:w-[40%]',
    ctaDirection: 'flex-col',
  },
  col: {
    desktopDirection: 'lg:flex-col',
    mobileDirection: 'max-lg:flex-col',
    gap: 'gap-y-14',
    ctaDirection: 'flex-row max-lg:flex-col lg:items-center lg:justify-between',
  },
  'col-reverse': {
    desktopDirection: 'lg:flex-col-reverse',
    mobileDirection: 'max-lg:flex-col-reverse',
    gap: 'gap-y-14',
    ctaDirection: 'flex-row max-lg:flex-col lg:items-center lg:justify-between',
  },
};
